import { convertUTCToLocal } from "@/utility/dateHelper";

export const GetFormattedProductData = (apiResponse = {}) => {
    const {
        statusCode,
        success,
        message,
        data,
    } = apiResponse;

    const formattedData = formatProductData(data);

    return {
        statusCode,
        success,
        message,
        data: formattedData ? formattedData :[],
    };
};

// Helper function to map and format the response
const formatProductData = (data = {}) => {
    return {
        ...data,
        baseData: {
            ...data?.baseData,

        },
        additionalInfo: {
            ...data?.additionalInfo,
        },
        display: {
            ...data?.display,
        },
        brandInfo: {
            ...data?.brandInfo,
        },
        category: {
            ...data?.category,
        },
        taxes: data?.taxes?.map(tax => ({
            ...tax,
        })) || [],
        saleUoms: data?.saleUoms?.map(saleUom => ({
            ...saleUom,
        })) || [],
        media: {
            ...data?.media,
        },
    };
};
